<template>
  <div
    v-for="(item, index) in renderRoomTypes(getRoomType(screen))"
    :key="index">
    {{ item }}
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    screen: {
      default() {
        return {}
      },
      type: Object,
    },
    roomFilters: {
      default() {
        return {}
      },
      type: Object,
    },
    selectedRoom: {
      default: '',
      type: String,
    },
  },
  methods: {
    getRoomType(screen) {
      return this.roomFilters
        .filter((sc) => screen.roomTypes.includes(sc.value))
        .map((item) => item.display)
        .join(',')
    },
    renderRoomTypes(string) {
      return string.split(',')
    },
  },
}
</script>
